<template>
    <div>
        <div calss="">
            <HomeVue v-if="view == 'home'" />
            <!-- <AsistenciaVue @setView="setView" v-if="view == 'asistencia'" /> -->
            <MaintenanceVue @setView="setView" v-if="view == 'mantenimiento'" />

            <CloseBeadVue @setView="setView" v-if="view == 'close_bead'" />
            
            <ProccessVue v-if="view == 'proccess'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
            
            <ReportView v-if="view == 'reports'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
        </div>
        <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
    </div>
</template>

<script>
import FooterVue from "../../components/Recepcionist/demo/Footer.vue";
import HomeVue from "../../components/Recepcionist/demo/Home.vue";
import ProccessVue from '../proccess/ProccessView.vue';
import MaintenanceVue from "../../views/maintenance/index.vue";
import CloseBeadVue from "../../components/caja/demo/page/CloseBead.vue";
// import AsistenciaVue from "../../components/asistencia/Asistencia.vue";
import ReportView from '../reports/ReportsView.vue';


export default {
    components: { FooterVue, HomeVue, MaintenanceVue, ProccessVue, CloseBeadVue,ReportView },
    data() {
        return {
            view: "home",
        };
    },
    methods: {
        setView: function (payload) {
            this.view = payload;
        },
        mtdViewFooter: function (boo, view) {
            this.booFooter = boo;
            if (boo == true) this.view = view;
        }
    },
};
</script>

<style lang="scss" scoped></style>